"use strict";

import "./Button.css";
import React from "react";
import classnames from "classnames";
import Icon from "./../Icon";
import SVGIcon from "svg-inline-loader/lib/component.jsx";

export default class Button extends React.Component {
	
	renderPicture() {
		if (this.props.svg) {
			return <SVGIcon src={this.props.svg}/>
		} else if (this.props.icon) {
			return <Icon>{this.props.icon}</Icon>
		}
	}
	
	renderChildren() {
		if (this.props.children && this.props.children.constructor === String)
			return <span>{this.props.children}</span>;
		else
			return this.props.children;
	}
	
	render() {
		const className = classnames(this.props.className, "Button");
		return (
			<button {...this.props} className={className}>
				{this.renderPicture()}
				{this.renderChildren()}
			</button>
		);
	}
	
}


// WEBPACK FOOTER //
// ./~/vwa/components/Button/Button.jsx